export enum Locales {
    Pl = 'PL',
}

export interface Locale {
    key: Locales;
    name: string;
}